import moment from 'moment';

// todo internationalise this!
export const DATE_FORMAT = 'DD/MM/YYYY';
export const DATE_TIME_FORMAT = 'DD/MM/YYYY hh:mm A';
export const TIME_FORMAT = 'hh:mm A';

/** Utility function to render a cell as a formatted date, can be passed to the column definition to render as such */
export function dateCell(value?: string) {
	if (!value)
		return '';
	return moment(value).format(DATE_FORMAT);
}


/** Utility function to render a cell as a formatted date, can be passed to the column definition to render as such */
export function dateTimeCell(value?: string) {
	if (!value)
		return '';
	return moment(value).format(DATE_TIME_FORMAT);
}


/** Utility function to render a cell as a formatted time, can be passed to the column definition to render as such */
export function timeCell(value?: string) {
	if (!value)
		return '';
	return moment(value).format(TIME_FORMAT);
}
